export default __webpack_public_path__ + "static/media/RT_3.d8f6e28d.png";